import React from "react";

import { SYSTEM_ADMIN_PATH } from "../../../../constants";

const Dashboard = React.lazy(() => import('../Dashboard'));

const routes = {
     path: SYSTEM_ADMIN_PATH.DASHBOARD, // Must have 1 path with '/', so useRoutes of react-router-dom won't cause issues
     breadcrumb: "Dashboard", // To display for breadcrumb
     element: <Dashboard />
};

export default routes;
